<template>
    <div>
        <app-navbar :user="user"
                    :profile-data="filterProfileData"
                    :selected-language="userLanguage"
                    :language-data="languages"
                    notification-component="app-custom-notification-dropdown"
                    :notification-data="notifications.data"
                    :total-unread="notifications.total"
                    :logo-url="logoIconSrc"
                    :allNotificationUrl="allNotificationUrl"
                    :show-identifier="!!notifications.total_unread"
                    @clicked="readNotification"
                    @loadNotifications="loadNotification">
            <template v-if="isTenantExist" slot="left-option">
                <button class="navbar-toggler shadow-none pl-0">
                    <app-tenant-manager/>
                </button>
            </template>
            <template v-if="user.has_wallet" slot="left-option">
                <button class="navbar-toggler shadow-none ">
<!--                    <app-tenant-manager/>-->
<!--                  <div class="rounded-circle">-->
<!--                    -->
<!--                  </div>-->
                  <a class="text-size-14">
                    {{ user.balance }} {{ $t('points') }}
<!--                    <i class="fa fa-chevron-right"></i>-->
                  </a>
                </button>
            </template>

        </app-navbar>

<!--      <default-location-create-edit-modal-->
<!--          v-if="locationModal"-->
<!--          v-model="locationModal"-->
<!--          :selected-url="selectedUrl"-->
<!--          :make-default="true"-->
<!--          @close="locationModal = false"-->
<!--      />-->

<!--      <app-department-modal-->
<!--          v-if="departmentModal"-->
<!--          v-model="departmentModal"-->
<!--          :make-default="true"-->
<!--          :selected-url="selectedUrl"-->
<!--          @close="departmentModal=false"-->
<!--      />-->

<!--      <app-designation-modal-->
<!--          v-if="designationModal"-->
<!--          v-model="designationModal"-->
<!--          :selected-url="null"-->
<!--          :make-default="true"-->
<!--          @close="designationModal = false"-->
<!--      />-->

<!--        <app-working-shift-modal-->
<!--            v-if="workShiftModal"-->
<!--            v-model="workShiftModal"-->
<!--            :make-default="true"-->
<!--            @close="workShiftModal = false"-->
<!--        />-->

<!--      <employee-create-edit-model-->
<!--          v-if="employeeModal"-->
<!--          v-model="employeeModal"-->
<!--          :make-default="true"-->
<!--          :selected-url="''"-->
<!--      />-->


      <div v-if="companyFormationPending === 1">
        <app-tenant-step-wizard
            :make-default="true"
            :current-step="currentStep"
            :has-location-created="hasLocationCreated"
            :has-department-created="hasDepartmentCreated"
            :has-designation-created="hasDesignationCreated"
            :has-working-shift-created="hasWorkShift"
        />
      </div>

    </div>
</template>

<script>
import CoreLibrary from "../../../core/helpers/CoreLibrary";
import {mapActions, mapState} from 'vuex'
import {axiosPost, urlGenerator} from "../../Helper/AxiosHelper";
import LocationCreateEditModal from "../../../tenant/Components/View/Location/LocationCreateEditModal";
import EmployeeCreateEditModel from "../../../tenant/Components/View/Employee/EmployeeCreateEditModal";
import TenantStepWizard from "../../../tenant/Components/View/Wizard/TenantStepWizard";
import DefaultLocationCreateEditModal from "../../../tenant/Components/View/Location/DefaultLocationCreateEditModal";

export default {
  components: {DefaultLocationCreateEditModal, EmployeeCreateEditModel, TenantStepWizard},
    name: "TopBar",
    extends: CoreLibrary,
    props: {
        profileData: {},
        logoIconSrc: {
            type: String,
            default: '/images/logo.png'
        },
        companyFormationPending:{
            type: Number,
            default: 1
        },
        hasWorkShift:{
            type: Number,
            default: 0
        },
        hasLocationCreated:{
            type: Number,
            default: 0
        },
        hasDepartmentCreated:{
            type: Number,
            default: 0
        },
        hasWorkingShiftCreated:{
            type: Number,
            default: 0
        },
        hasDesignationCreated:{
            type: Number,
            default: 0
        },
        // hasEmployeeCreated:{
        //     type: Number,
        //     default: 0
        // },
    },
    data() {
        return {
            user: {},
            workShiftModal: false,
            locationModal: false,
            employeeModal: false,
            departmentModal: false,
            designationModal: false,
            selectedUrl: "",
            steps: 5,
            currentStep: -1,
            // companyFormed: false
        }
    },
    computed: {
        ...mapState({
            languages: state => state.support.languages
        }),
        userLanguage() {
            if (window.appLanguage) {
                return window.appLanguage.toUpperCase();
            }
        },
        notifications() {
            return this.$store.getters.getFormattedNotifications
        },
        isTenantExist() {
            return !!window.tenant && !window.tenant.is_single;
            // return true;
        },
        tenant() {
            return window.tenant || {};
        },
        allNotificationUrl(){
            return this.profileData.find(data => data.optionName === this.$t('notifications'))?.url;
        },
        filterProfileData(){
            return this.profileData.filter(item => item.length !== 0);
        }
    },
    methods: {
        ...mapActions([
            'getLanguages'
        ]),
        setUser() {
            this.user = {
                full_name: this.$optional(window.user, 'full_name'),
                img: this.$optional(window.user, 'profile_picture', 'full_url') ||
                    urlGenerator('/images/avatar.png'),
                status: this.$t('online'),
                role: window.user.roles && window.user.roles.length ? window.user.roles[0].name : '',
                balance: window.user.balance ?? 0,
                has_wallet: window.user.has_wallet,
            };
        },
        checkContractExpired() {

          if(window.user.is_contract_expired) {
            this.$toastr.Add({
              name: "ContractExpiredToast",
              title: this.$t('contract_expired'),
              msg: this.$t('please_renew_your_contract'),
              clickClose: true,
              timeout: 0,
              closeButton: true,
              type: "error",
              progressBar: false,
            });
          }
        },
        readNotification(notification) {
            axiosPost(`admin/user/notifications/mark-as-read/${notification.id}`).then(({data}) => {
                if (data.data.url) {
                    window.location = data.data.url;
                }
                this.$store.dispatch('getNotifications');
            });
        },
        checkDefaultLocation() {
          this.hasLocationCreated !== 0 ? this.locationModal = false : this.locationModal = true;
          this.currentStep = 1;
        },
        checkDefaultDepartment() {
          this.hasDepartmentCreated !== 0 ? this.departmentModal = false : this.departmentModal = true;
          this.currentStep = 2;
        },
        checkDefaultDesignation() {
          this.hasDesignationCreated !== 0 ? this.designationModal = false : this.designationModal = true;
          this.currentStep = 3;
        },
        checkDefaultWorkShift() {
          this.hasWorkShift !== 0 ? this.workShiftModal = false : this.workShiftModal = true;
          this.currentStep = 4;
        },
        /*checkDefaultEmployee() {
          this.hasEmployeeCreated !== 0 ? this.employeeModal = false : this.employeeModal = true;
          this.currentStep = 5;
        },*/
        loadNotification(){
           if(this.notifications?.next_page_url){
               this.$store.dispatch('getNotifications', Number(this.notifications.current_page) + 1);
           }
        },
        tenantWizard(currentStep) {
            switch (currentStep)
            {
              case 1:
              {
                if(!this.hasLocationCreated) {
                  this.locationModal = true;
                }
                break;
              }
              case 2:
                if(!this.hasDepartmentCreated) {
                  this.departmentModal = true;
                }
                break;
              case 3:
                if(!this.hasDesignationCreated) {
                  this.designationModal = true;
                }
                break;
              case 4:
                if(!this.hasWorkShift) {
                  this.workShiftModal = true;
                }
                break;
              /*case 5:
                if(!this.hasEmployeeCreated) {
                  this.employeeModal = true;
                }
                break;*/
            }
        },
    },
    created() {
        this.getLanguages();
    },
    mounted() {
      this.currentStep =
          this.hasLocationCreated === 0 ? 1
              : this.hasDepartmentCreated === 0 ? 2
                  : this.hasDesignationCreated === 0 ? 3
                      : this.hasWorkShift === 0 ? 4
                          : 5;
        this.setUser();
        this.checkContractExpired();
        this.tenantWizard(this.currentStep);
        this.$store.dispatch('getNotifications');
    }
}
</script>
